import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NextCoachingInsightService } from '../../coaching-base/coaching-insight.service';
import { catchErrorLogRet } from '../../common/rest.operators';
import { Dependencies } from '../../store';
import { PayloadAction } from '../../store.model';
import { User } from '../../user/user.model';
import { UserService } from '../../user/user.service';

import {
    ActionType,
    InitAction,
    reloadResult,
    SelectUserAction,
    selectUserResult,
} from './insight-widget.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const rootReload = (
    action: ActionsObservable<PayloadAction<ActionType, InitAction>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.COACHING_INSIGHT__RELOAD),
        switchMap((act: PayloadAction<ActionType, InitAction>) => {
            const coachingInsightService =
                deps.injector.get<NextCoachingInsightService>(
                    NextCoachingInsightService,
                );

            const obses = [
                coachingInsightService.retrieveInsightsSummaryData(
                    act.payload.userId,
                    act.payload.periodTypeId,
                    act.payload.periodDate,
                ),
            ];

            return forkJoin(obses).pipe(
                map((ret) =>
                    reloadResult(
                        {
                            ...act.payload,
                            insightSummaryData: ret[0],
                        },
                        act.storePath,
                    ),
                ),
                catchError((e) => {
                    console.log(e);
                    return of(reloadResult({ ...act.payload }, act.storePath));
                }),
            );
        }),
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const rootSelectUser = (
    action: ActionsObservable<PayloadAction<ActionType, SelectUserAction>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.COACHING_INSIGHT__SELECT_USER),
        switchMap((act: PayloadAction<ActionType, SelectUserAction>) => {
            const service = deps.injector.get<UserService>(UserService);

            const obses: [Observable<User>, Observable<string>] = [
                service.retrieve(act.payload.userId).pipe(catchErrorLogRet({})),
                service
                    .retrievePhoto(act.payload.userId)
                    .pipe(catchErrorLogRet(null)),
            ];

            return forkJoin(obses).pipe(
                map((ret) =>
                    selectUserResult(
                        {
                            ...act.payload,
                            user: ret[0],
                            userImage: ret[1],
                        },
                        act.storePath,
                    ),
                ),
                catchError((e) => {
                    console.log(e);
                    return of(
                        selectUserResult({ ...act.payload }, act.storePath),
                    );
                }),
            );
        }),
    );

export default [rootReload, rootSelectUser];
